<template>
  <div class="page">
    <h2>Hoe kunnen we je bereiken?</h2>
    <p class="paragraph">
      De resultaten staan voor je klaar. Benieuwd naar wat zonnepanelen huren jou oplevert? Vul onderstaande gegevens in om je aanvraag af te ronden.
    </p>
    <form class="page-form">
      <div class="form-row">
        <div class="form-col form-col-medium">
          <label>Voornaam</label>
          <input v-model="voornaam" type="text" placeholder="Jan" />
        </div>
        <div class="form-col form-col-large">
          <label>Achternaam</label>
          <input v-model="achternaam" type="text" placeholder="De Vries" />
        </div>
      </div>
      <div class="form-row">
        <div
          class="form-col form-col-medium"
          :class="{invalid : !phonenumber_validated}">
          <label>Telefoon<span>*</span></label>
          <input
            v-on:focus="phonenumber_validated = true"
            v-on:blur="validate_phonenumber"
            v-model="telefoon"
            type="phone"
            placeholder="06 xxx xxx xx" />
        </div>
        <div class="form-col form-col-large"
          :class="{invalid : !emailaddress_validated}">
          <label>E-mailadres<span>*</span></label>
          <input
            v-on:focus="emailaddress_validated = true"
            v-on:blur="validate_emailaddress"
            v-model="emailadres"
            type="email"
            placeholder="jan@mail.nl"/>
        </div>
      </div>
      <div class="form-row">&nbsp;</div>
      <div class="form-row">
        <div class="toggle-labeled">
          <toggle
            v-model="optionAanbod"
            label-checked="ja"
            label-unchecked="nee" />
          <label>Ik wil nog meer besparen, doe mij een vrijblijvend aanbod voor de levering van energie</label>
        </div>
      </div>
      <div v-if="optionAanbod" class="form-row message">
        <p>
          Om je een aanbieding te kunnen doen voor de levering van energie delen wij jouw gegevens met onze partner Mijndomein Energie.
        </p>
      </div>
      <div class="form-row">
        <div class="toggle-labeled">
          <toggle
            v-model="optionVoorwaarden"
            label-checked="ja"
            label-unchecked="nee" />
          <label>Ik ga akkoord met de <a target="_BLANK" href='/algemene-voorwaarden'>algemene voorwaarden</a></label>
        </div>
      </div>
      <div class="form-row nav-buttons">
        <button v-bind:class="{ enabled : isCompleted }" v-on:click="next()" type="button">Volgende</button>
      </div>
    </form>
  </div>
</template>

<script>
  import toggleComponent from './../components/toggleComponent.vue';
  import validations from './../plugins/validations.js';

  export default {
    name: 'gegevensPage',
    components: {
      'toggle' : toggleComponent
    },
    mounted() {
      this.$store.dispatch('set_step_to', this.step)
    },
    data : function(){
      return{
        step: 3,
        phonenumber_validated : true,
        emailaddress_validated : true,
      }
    },
    computed: {
      isCompleted() {
        return this.$store.getters.is_completed_step(this.step)
      },
      voornaam: {
        get () { return this.$store.state.userData.voornaam },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'voornaam', value: value, step: 3 }) }
      },
      achternaam: {
        get () { return this.$store.state.userData.achternaam },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'achternaam', value: value, step: 3 }) }
      },
      telefoon: {
        get () { return this.$store.state.userData.telefoon },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'telefoon', value: value, step: 3 }) }
      },
      emailadres: {
        get () { return this.$store.state.userData.emailadres },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'emailadres', value: value, step: 3 }) }
      },
      optionVoorwaarden: {
        get () { return this.$store.state.userData.option_voorwaarden },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'option_voorwaarden', value: value, step: 3 }) }
      },
      optionAanbod: {
        get () { return this.$store.state.userData.option_aanbod },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'option_aanbod', value: value, step: 3 }) }
      },
    },
    methods : {
      validate_emailaddress() {
        this.emailaddress_validated = validations.email(this.emailadres)
      },
      validate_phonenumber() {
        this.phonenumber_validated = validations.phonenumber_nl(this.telefoon)
      },
      next() {
        if( this.isCompleted == true ) {
          this.$router.push('/resultaten')
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .toggle-labeled {
    position: relative;
    width: 100%;

    label {
      position: absolute;
      top: 21px;
      left: 90px;
      right: 0;
    }
  }

  .form-row {
    &.message {
      position: relative;
      width: 550px;
      max-width: 100%;
      padding: 8px 20px;
      margin: 10px 0 20px 0;
      font-size: 0.9em;
      color: $color-primary;
      background: $color-yellow-dark;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 0;
        margin-left: -8px;
        margin-top: -13px;
        border-left: 13px solid transparent;
        border-right: 13px solid transparent;
        border-bottom: 13px solid $color-yellow-dark;
        z-index: -2;
      }

    }
  }
</style>
